import { Component, OnInit, ViewChild } from '@angular/core';
import { EngagementsService } from 'src/app/services/panelM/update-params/engagements.service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditAdminFieldComponent } from '../../edit-admin-field/edit-admin-field.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AdminModalConfirmComponent } from '../../admin-modal-confirm/admin-modal-confirm.component';

@Component({
  standalone: false,
  selector: 'app-engagement',
  templateUrl: './engagement.component.html',
  styleUrls: ['./engagement.component.scss']
})
export class AdminEngagementComponent implements OnInit {

  params: any;
  displayedColumns: string[] = ['Channel', 'OBChannel', 'UrlOK', 'UrlKO', 'tyc', 'button', 'delete'];
  mapTyc = {
    1: 'Veracidad',
    2: 'Veracidad y evaluacón'
  }
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private obService: EngagementsService,
    private router: Router,
    private snackBar: MatSnackBar,
    private readonly modal: MatDialog
  ) { }

  ngOnInit() {
    this.initData();
  }


  updateRow(element) {
    if (element.tyc) {
      element.tyc = Number(element.tyc);
    }
    this.obService.updateObService(element).subscribe((data: any) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    }, (data) => {
      this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
        duration: 3000,
      });
    });
  }

  private addId(list: any) {
    list.map((element, index) => {
      element.id_row = index + 1;
    });
    return list;
  }

  private initData() {
    this.obService.obInfoService().subscribe((data: any) => {
      if (data) {
        this.params = new MatTableDataSource<any>(this.addId(data.TrancksList));
        this.params.paginator = this.paginator;
      }
    }, error => {
      console.error(error);
      this.router.navigateByUrl('/portalM');
    });
  }

  /**
   * Abre el modal EditAdminFieldComponent para creación o edición de una contratación inicializando el formulario y los valores para pasar a dichp modal
   * 
   * Una vez cerrado el modal, llama al servicio de crear o actualizar la contratación con los valores introducidos en el modal
   * @param [element] 
   * @returns void
   */
  openCreateModal(element: any = {}): void {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-admin';
    modalConfig.maxWidth = '500px';
    modalConfig.maxHeight = '614px';
    modalConfig.disableClose = true;
    modalConfig.data = {
      title: element.Id ? 'Editar contratación' : 'Crear nueva contratación',
      buttonText: element.Id ? 'Editar' : 'Crear',
      element: element,
      formFields: {
        Channel: {
          text: 'Canal',
          value: 3,
          values: [
            {
              text: 3,
              value: 3
            },
            {
              text: 4,
              value: 4
            }
          ]
        },
        OBChannel: {
          value: '',
          text: 'Canal de contratación'
        },
        UrlOK: {
          text: 'URL OK',
          value: '',
        },
        UrlKO: {
          text: 'URL KO',
          value: ''
        },
        tyc: {
          text: 'TyC',
          value: 1,
          values: [
            {
              text: 'Veracidad',
              value: 1
            },
            {
              text: 'Veracidad y evaluación',
              value: 2
            }
          ]
        },
      }
    }
    const mod = this.modal.open(EditAdminFieldComponent, modalConfig);
    mod.afterClosed().subscribe(data => {
      if (data) {
        data.tyc = Number(data.tyc);
        data.Channel = Number(data.Channel)
        if (element.Id) {
          data.Id = element.Id;
          this.obService.updateObService(data).subscribe((res: any) => {
            this.initData();
          }, (data) => {
            this.snackBar.open((data.Ok) ? 'Actualización correcta' : 'Error al actualizar', '', {
              duration: 3000,
            });
          });
        } else {
          this.obService.updateObService(data).subscribe(() => this.initData());
        }
      }
    })
  }

  openDeleteModal(element) {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-admin';
    modalConfig.maxWidth = '500px';
    modalConfig.maxHeight = '215px';
    modalConfig.disableClose = true;
    modalConfig.data = {
      title: 'Aviso',
      message: '¿Quieres borrar esta contratación?',
      accept: 'Borrar',
      cancel: 'Cancelar'
    }
    const mod = this.modal.open(AdminModalConfirmComponent, modalConfig);
    mod.afterClosed().subscribe(data => {
      if (data) {
        this.obService.deleteObService(element.Id).subscribe(() => this.initData());
      }
    })
  }
}
